export const BARCODE_SCAN = 'BARCODE_SCAN';
export const BARCODE_REG = 'BARCODE_REG';
export const ACTION_BARCODE_START = 'ACTION_BARCODE_START';
export const ACTION_BARCODE_END = 'ACTION_BARCODE_END';
export const CHANGE_BARCODE_STATE_LOCAL = 'CHANGE_BARCODE_STATE_LOCAL';

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
